<div class="alert alert-danger" role="alert" *ngIf="payByBankStatus && payByBankStatus !== 'approved'">
    <span *transloco="let t">{{t('paybybank.error.decline')}}</span>
</div>

<div class="card-body" *transloco="let t">
    <app-merchant-response></app-merchant-response>
    <form [formGroup]="billingInformation">
        <fieldset>
            <legend>
                <h3 class="pb-2 pymnt_cc__header font_family__standard">{{t('billing.info')}}</h3>
            </legend>
            <ng-container *ngIf="gd?.oscConfig?.displayBillingName">
                <app-billing-name-information formGroupName="nameDetails" [orderData]="orderData" [spcOscCode]="spcOscCode"></app-billing-name-information>
            </ng-container>
            <ng-container *ngIf="gd?.oscConfig?.displayBillingAddress">
                <app-billing-address-information formGroupName="addressDetails" [orderData]="orderData" [spcOscCode]="spcOscCode"></app-billing-address-information>
            </ng-container>
        </fieldset>
    </form>
    <div class="col-lg-12">
        <div class="col-lg-12 pt-2 sub-text alipay-font font_family__standard">
            <div class="lock">
                <fa-icon [icon]="faLock"></fa-icon>
            </div>
            {{t('billing.ets.pymt.text')}}
        </div>
        <div class="col-lg-12">
            <button id="submit" [ngClass]="billingInformation.invalid ? 'disabled-bkg-pbb' : 'btn--primary-pbb'" class="processing-button" [disabled]="billingInformation?.invalid" (click)="createPayByBankPayment()">
                <fa-icon [icon]="faLock"></fa-icon>
                <span class="cc_submit font_family__standard">{{t('btn.process.payment')}} (${{orderData?.amount | number : '1.2-2'}} <span>USD</span>)</span>
            </button>
        </div>
    </div>
</div>

<!-- Stub Modal -->
<ng-template #modalContent let-modal>
    <div id="payByBankModal" class="modal-body pay-by-bank-modal" *transloco="let t">
        <div class="modal-header">
            <h2 class="title">{{ t('paybybank.stub.title') }}</h2>
            <button type="button" class="btn-close" (click)="modal.dismiss('cancel')" aria-label="Close modal">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-content-wrapper">
            <div class="pay-by-bank">
                <form #stubForm="ngForm" role="form" aria-labelledby="status-label">
                    <div class="status-label" id="status-label">
                        {{ t('paybybank.stub.select.status') }}
                    </div>
                    <div class="form-check-group">
                        <div class="form-check">
                            <input id="success" type="radio" name="status" value="APPROVED" required [(ngModel)]="stubUserChoice" #userchoice="ngModel" class="form-check-input" (change)="onStubChoiceSelected('APPROVED')">
                            <label class="form-check-label" for="success">
                                {{ t('paybybank.stub.success') }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input id="cancel" type="radio" name="status" value="CANCEL" required [(ngModel)]="stubUserChoice" class="form-check-input" (change)="onStubChoiceSelected('CANCEL')">
                            <label class="form-check-label" for="cancel">
                                {{ t('paybybank.stub.cancel') }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input id="failed" type="radio" name="status" value="ERROR" required [(ngModel)]="stubUserChoice" class="form-check-input" (change)="onStubChoiceSelected('ERROR')">
                            <label class="form-check-label" for="failed">
                                {{ t('paybybank.stub.failed') }}
                            </label>
                        </div>
                        <div class="alert alert-danger" *ngIf="userchoice.touched && userchoice.invalid" role="alert">
                            {{ t('paybybank.stub.select.option') }}
                        </div>
                    </div>
                    <button type="button" id="payByBankStubBtn" class="btn btn-primary" [disabled]="!stubForm.valid" aria-label="Submit payment" (click)="modal.close(stubUserChoice)">
                        {{ t('paybybank.stub.pay') }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</ng-template>